var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"19f2e608d8d512068c0abac92379cffc82a35631"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gatsby-website@oddboxhq"]={id:"19f2e608d8d512068c0abac92379cffc82a35631"};
      